module.exports = __webpack_public_path__ + "img/dycar-logo.7d5794c1.webp";